import { queryOptions, useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, useNavigate } from "@tanstack/react-router"

import { ChangelogTabs } from "@/components/changelog/changelog-tabs"
import { EntryForm } from "@/components/changelog/entry-form"
import { getEntry } from "@/http/changelog/entries"

const entryQueryOptions = (
  serviceId: string,
  entryId: string,
  organizationSlug: string,
) =>
  queryOptions({
    queryKey: ["changelog-entry", serviceId, organizationSlug, entryId],
    queryFn: async () => {
      const response = await getEntry({
        serviceId,
        entryId,
        organizationSlug,
      })
      if (response.error) throw new Error(response.error.message)
      return response.data
    },
  })

export const Route = createFileRoute(
  "/_authenticated/$orgSlug/changelog/services/$serviceId/entries/$entryId",
)({
  loader: async ({ context, params }) => {
    await context.queryClient.ensureQueryData(
      entryQueryOptions(params.serviceId, params.entryId, params.orgSlug),
    )
    return {
      title: "Editar entry",
      path: `/${params.orgSlug}/changelog/services/${params.serviceId}/entries/${params.entryId}`,
    }
  },
  component: EditEntryPage,
})

function EditEntryPage() {
  const { orgSlug, serviceId, entryId } = Route.useParams()
  const navigate = useNavigate()

  const { data: entry } = useSuspenseQuery(
    entryQueryOptions(serviceId, entryId, orgSlug),
  )

  return (
    <div className="space-y-6">
      <ChangelogTabs
        orgSlug={orgSlug}
        serviceId={serviceId}
        activeTab="entries"
      />
      <div>
        <h1 className="text-2xl font-bold md:text-3xl">Editar entry</h1>
        <p className="text-muted-foreground">Edite a entry do changelog</p>
      </div>

      <EntryForm
        entryId={entryId}
        serviceId={serviceId}
        organizationSlug={orgSlug}
        defaultValues={{
          title: entry.title,
          content: entry.content ?? "",
          publishedAt: entry.publishedAt ?? "",
          isPublished: entry.isPublished,
          tagIds: entry.tags.map((t) => t.id),
        }}
        onSuccess={() =>
          navigate({
            to: "/$orgSlug/changelog/services/$serviceId/entries",
            params: { orgSlug, serviceId },
          })
        }
      />
    </div>
  )
}
